import PropTypes from 'prop-types';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

import { usePopover } from 'src/hooks/use-popover';

import { TenantPopover } from './tenant-popover';
import { useTranslation } from 'react-i18next';

const tenants = ['Devias', 'Acme Corp'];

export const TenantSwitch = (props) => {
  const popover = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={{ xs: 1, sm: 2 }}
        sx={{ minWidth: 0, overflow: 'hidden' }}
        {...props}>
        <Box sx={{ flexGrow: 1, minWidth: 0, overflow: 'hidden' }}>
          <Typography
            color="inherit"
            noWrap
            sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, fontWeight: 700, lineHeight: 1.2, opacity: 0.95 }}
            variant="h6"
          >
            {t("Al Shashah")}
          </Typography>
          <Typography
            color="neutral.400"
            noWrap
            sx={{ fontSize: { xs: '0.6875rem', sm: '0.75rem' } }}
            variant="body2"
          >
            {t("Fashion")}
          </Typography>
        </Box>
        {/* <IconButton
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
        >
          <SvgIcon sx={{ fontSize: 16 }}>
            <ChevronDownIcon />
          </SvgIcon>
        </IconButton> */}
      </Stack>
      {/* <TenantPopover
        anchorEl={popover.anchorRef.current}
        onChange={popover.handleClose}
        onClose={popover.handleClose}
        open={popover.open}
        tenants={tenants}
      /> */}
    </>
  );
};

TenantSwitch.propTypes = {
  sx: PropTypes.object
};
